import MultiDatePicker from '../../atoms/multi-date-picker/multi-date-picker'

export type YearlyCalendarProps = {
  editableDates: Date[]
  onUserSelection: (userSelectedDates: Date[]) => void
  readonlyDates: Date[]
}

const YearlyCalendar = ({ editableDates, onUserSelection, readonlyDates }: YearlyCalendarProps) => (
  <div>
    <MultiDatePicker
      editableDates={editableDates}
      readonlyDates={readonlyDates}
      onUserSelection={onUserSelection}
    />
  </div>
)

export default YearlyCalendar
